import { Component, OnInit } from '@angular/core';
import { environment } from 'apps/partner-web/src/environments/environment';

@Component({
  selector: 'fitscovery-ui-bottom-navbar',
  templateUrl: './ui-bottom-navbar.component.html',
  styleUrls: ['./ui-bottom-navbar.component.scss']
})
export class UiBottomNavbarComponent implements OnInit {

  accountUrl: string = environment.fitscoveryApps.accountUrl;
  myDiscoveryUrl: string = environment.fitscoveryApps.myDiscoveryUrl;

  constructor() { }

  ngOnInit(): void {

  }

}
